<template>
  <div class="form_">
    <cube-form
      :model="form"
      @validate="validateHandler"
      @submit="submitHandler">
      <div class="title_">
        基本信息
      </div>
      <cube-form-group style="padding: 0 15px;">
        <cube-form-item :field="InsFieldsExtend[0]">
          <div
            class="select_"
            @click="commonPicker('channelTypeP', channelTypeOptions)"
          >
            <span>
              {{
                form.channelType
                  | filCommon(channelTypeOptions, "请选择所属行业")
              }}
            </span>
            <span class="down_"> </span>
          </div>
        </cube-form-item>
        <cube-form-item :field="InsFieldsExtend[1]">
          <div class="select_" @click="commonPicker('cporpaP', cporpaOption)">
            <span>
              {{ form.cporpa | filCommon(cporpaOption, "请选择主体类型") }}
            </span>
            <span class="down_"> </span>
          </div>
        </cube-form-item>
        <cube-form-item :field="InsFieldsExtend[2]">
          <cube-input
            v-model="form.channelName"
            @input="handleChange"
            placeholder="请输入公司/工作室名称"
          ></cube-input>
        </cube-form-item>

        <cube-form-item :field="InsFieldsExtend[3]">
          <cube-input
            v-model="form.adminName"
            @input="handleChange"
            placeholder="请输入联系人姓名"
          ></cube-input>
        </cube-form-item>
        <cube-form-item :field="InsFieldsExtend[4]">
          <cube-input
            v-model="form.adminPhone"
            @input="handleChange"
            @blur="handleBlur1"
            :eye="eye"
            placeholder="请输入联系人电话"
          ></cube-input>
        </cube-form-item>
      </cube-form-group>

      <cube-button
        type="submit"
        :class="[disabled ? 'gray_' : '']"
        :disabled="disabled"
        class="btn_"
        >下一步</cube-button
      >
      
    </cube-form>
    <!-- <p class="tip_">
        客户经理:<span>{{ userInfo.userName }}</span> 电话:<span>{{
          userInfo.userTel
        }}</span>
      </p> -->
      <div class="bottom_">
        <div class="tip_">南燕客服电话：400-820-3433</div>
        <div class="bom_1">
          <a>
            <img src="../../../assets/image/invite/manager.png" alt="">
            客户经理：<span>{{ userInfo.userName }}</span>
          </a>
          <a>
            <img src="../../../assets/image/invite/tel.png" alt="">
            电话：<span>{{ userInfo.userTel }}</span>
          </a>
        </div>
      </div>
      <div class="out_" v-if="showModel">
        <img class="arrow_" src="../../../assets/image/invite/arrow_.png" alt="">
        <div class="inner_">
          <div class="close_" @click="close">X</div>
          <div class="share_">点击右上角分享，发送给好友吧</div>
        </div>
      </div>
    <!-- <p class="tip_">点击右上角"..." 转发邀请页面</p> -->
  </div>
</template>

<script>
import api from "@/utils/api";
import options from "./options";
import common from "./common.js";
const required = {
  rules: {
    required: true
  }
};
const InsFieldsExtend = [
  //投保人扩展表
  {
    modelKey: "channelType",
    label: "行业",
    ...required
  },
  {
    modelKey: "cporpa",
    label: "主体类型",
    ...required
  },
  {
    modelKey: "channelName",
    label: "单位名称",
    ...required
  },
  {
    modelKey: "adminName",
    label: "联系人",
    ...required
  },
  {
    modelKey: "adminPhone",
    label: "联系人电话",
    ...required
  }
];

export default {
  filters: {
    filCommon(val, options, placeHolder) {
      let value = null;
      options.map(item => {
        if (val == item.value) {
          value = item.text;
        }
      });
      if (!value) {
        value = placeHolder;
      }
      return value;
    }
  },
  data() {
    document.title = '注册'
    return {
      showModel: true,
      showCode: true,
      eye: {
        open: true,
        reverse: false
      },
      channelTypeOptions: options.channelTypeOptions,
      cporpaOption: options.cporpaOption,
      InsFieldsExtend,
      form: {
        channelType: "",
        cporpa: "",
        channelName: "",
        adminName: "",
        adminPhone: ""
      },
      disabled: false,
      query: {},
      userInfo: {
        userName: "",
        userTel: ""
      },
      shareInfo: {}
    };
  },
  mounted() {
    // this.shareInfo = this.getSession('s_')
    this.query = this.$route.query;
    this.getNyManagerInfo().then(() => {
      this.inviteGetJsJdkSign();
    });
  },
  methods: {
    ...common,
    inviteGetJsJdkSign() {
      let url = location.href.split("#")[0];
      let _this = this;
      api
        .inviteGetJsJdkSign({
          url: url,
          userId: this.userId
        })
        .then(res => res.data)
        .then(async data => {
          const { appId, jssdkReqData } = data.content;
          console.log(appId, jssdkReqData);
          let options = {
            // debug: true,
            appId: appId, // 必填，公众号的唯一标识
            timestamp: jssdkReqData.timestamp, // 必填，生成签名的时间戳
            nonceStr: jssdkReqData.noncestr, // 必填，生成签名的随机串
            signature: jssdkReqData.signature, // 必填，签名，见附录1
            jsApiList: ["updateTimelineShareData", "updateAppMessageShareData"]
          };
          const { wxShare } = await this.$wx.wxConfig(options)
          let opstion = {
            title: _this.userInfo.shareName, // 分享标题
            link: window.location.href,
            imgUrl: _this.userInfo.sharePicuter, // 分享图标
            desc: _this.userInfo.shareAbstract,
            success: function() {
              console.log("success++");
            },
            error: function() {
              console.log("failed++");
            }
          };
          wxShare(opstion)
        });
    },
    handleBlur1() {
      let phoneR = /(^(0)?(13[0-9]|14[5|7|8|9]|15[0-9]|166|18[0-9]|17[0|1|3|5|6|7|8]|19[8|9])[0-9]{8}$)|(^(00852|00886|00853)[0-9]{1,15}$)/;
      if (!phoneR.test(this.form.adminPhone)) {
        this.showToast("请输入正确手机号");
        this.form.adminPhone = "";
      }
    },
    handleChange(e) {
      console.log(e, this.form);
      this.checkAllInfo();
    },
    checkAllInfo() {
      let form = this.form;
      let disable = false;
      for (let key in form) {
        if (!form[key]) {
          disable = false;
          // disable = true;
        }
      }
      this.disabled = disable;
    },
    getNyManagerInfo() {
      let data = {
        param: this.query.param
      };
      return api.getNyManagerInfo(data).then(res => {
        let content = res.data.content;
        if (content && content.userName) {
          this.userInfo = res.data.content;
        }
      });
    },
    //公共picker创建方法
    commonPicker(key, column) {
      let title = ''
      if (key == 'channelTypeP') {
        title = '行业'
      } else if(key == 'cporpaP') {
        title = '主体类型'
      }
      console.log(key, column, "===>");
      this.$createPicker({
        title: title,
        data: [column],
        onSelect: this[key]
      }).show();
    },
    channelTypeP(selectedVal, selectedIndex, selectedText) {
      this.form.channelType = selectedVal[0];
      this.checkAllInfo();
    },
    cporpaP(selectedVal, selectedIndex, selectedText) {
      this.form.cporpa = selectedVal[0];
      this.checkAllInfo();
    },
    submitHandler(e) {
      e.preventDefault();
      let form = this.form; //form数据
      form.param = this.query.param;
      let channelName = this.form.channelName
      api.checkChannenName(channelName).then(res => {
          this.setSession("f_", form);
          if (form.cporpa == "2") {
            this.$router.push({ name: "loginInfo", query: { cporpa: "2" } });
          } else {
            this.$router.push({ name: "upload" });
          }
        })
    },
    validateHandler(result) {
      this.validity = result.validity;
      this.valid = result.valid;
      console.log(
        "validity",
        result.validity,
        result.valid,
        result.dirty,
        result.firstInvalidFieldIndex
      );
    },
    close() {
      this.showModel = false
    }
  }
};
</script>

<style lang="scss" scoped>
.form_ {
  font-family: PingFangSC-Regular, PingFang SC;
  background: #fafafa;
  width: 100%;
  min-height: 100vh;
  position: relative;
  .title_ {
    font-size: 0.48rem;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    position: relative;
    text-align: left;
    padding: 0.33rem 0;
    padding-left: 20px;
    background: #f8f8f8;
    &::after {
      content: "";
      position: absolute;
      top: 33%;
      left: 0px;
      width: 0.07rem;
      height: 0.43rem;
      background: rgba(27, 124, 248, 1);
    }
  }
  .select_1 {
    text-align: left;
    color: rgba(51, 51, 51, 1);
  }
  .select_ {
    text-align: left;
    color: rgba(51, 51, 51, 1);
    // position: relative;
    .down_ {
      position: relative;
      height: 0.506667rem;
      width: 0.506667rem;
      display: inline-block;
      &::after {
        content: "";
        position: absolute;
        top: 0.3rem;
        right: 0.346667rem;
        width: 0;
        height: 0;
        border: 3px solid transparent;
        border-top-color: black;
      }
    }
  }

  .gray_ {
    background: #aaa !important;
    color: #fff !important;
  }
  .b_t_ {
    font-size: 12px;
    padding: 0 18px;
    text-align: left;
  }
  .btn_ {
    background: rgba(27, 124, 248, 1);
    font-size: 16px;
    font-weight: bold;
    border-radius: 5px;
    margin: 20px auto;
    color: #fff;
    width: 90% !important;
  }
  .bottom_ {
    width: 100%;
    padding: 0 15px;
    margin-top: 30vh;
    text-align: center;
    .tip_ {
      font-size: 14px;
      font-weight: 600;
      border-bottom: 1px #eee solid;
      padding-bottom: 10px;
      color: #000;
    }
    .bom_1 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      // height: 50px;
      font-size: 14px;
      font-weight: 600;
      padding-top: 10px;
      padding-left: 20px;
      a {
        display: flex;
        align-items: center;
        flex: 1;
        color: #000;
        font-weight: 600;
        img {
          margin-left: 5px;
          width: 16px;
        }
        &:first-child {
          border-right: 1px #eee solid;
        }
      }
    }
  }
  .out_ {
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    // padding: 30vh 10vw;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    .arrow_ {
      position: absolute;
      top: 12px;
      right: 12px;
      width: 20px;
    }
    .inner_ {
      position: relative;
      //   height: 100%;
      width: 90%;
      height: 70px;
      background: #fff;
      border-radius: 15px;
      // padding: 15px 25px;
      padding-top: 15px;
      .close_ {
        text-align: right;
        margin-top: 0;
        padding-right: 15px;
      }
      .share_ {
        font-weight: 600;
      }
      p {
        margin: 25px 0;
        text-align: center;
        font-weight: 500;
        span {
          width: 80px;
          display: inline-block;
        }
        label {
          margin: 0 0px 0 10px;
        }
      }
      .b_list_ {
        display: flex;
        justify-content: center;
        .btn_ {
          margin: 10px;
          color: #0079fe;
          padding: 10px 25px;
          border-radius: 10px;
        }
      }
      .btn_1 {
        width: 100px;
        height: 30px;
        border: 1px #eee solid;
        line-height: 28px;
        border-radius: 15px;
      }
      .active {
        color: #fff;
        background-color: #0079fe;
      }
      .bottom_ {
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        // position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 50px;
        line-height: 50px;
        border-top: 1px #eee solid;
        .btn {
          text-align: center;
          flex: 1;
           &:first-child {
            border-right: 1px #eee solid;
          }
        }
      }
    }
  }
}
</style>
